import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { debounce } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";

import Close from "../../../assets/images/close-icon.png";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ProfilePic from "../../../assets/images/dummy_profile.png";
import Loader from "../../../components/Loader/Loader";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "../../../components/common/css/datatable.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import PageShell from "../../../components/layout/PageShell";
import PageHead from "../../../components/layout/PageHead";
import { useRole } from "../../../hooks/useRole";
import { apiErrorMessage } from "../../../utils/apiError";
import { sendNamingAccountOnce } from "../../../utils/decisionAccount";

// Accreditation is a compliance decision. AD used to be the de-facto actor
// here, and the body even hardcoded approvedBy: "RootFundme-Team", which
// recorded a brand name where a regulated decision needs a person. The
// server records the actor now, so the client sends neither field.
const DECIDE_FORBIDDEN =
  "Only a Dealing Representative, CCO or UDP can decide accreditation.";
const OVERSIGHT_HINT = "Decided by a compliance reviewer";

const InvestorsList = () => {
  const { canDecide } = useRole();
  const [query, setQuery] = useState("");
  const [percentage, setPercentage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });

  const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const accreditedView = useSelector((state) => state.accreditedView);
  const { user } = accreditedView;
  const [id, setID] = useState();
  const [aiName, setAIName] = useState();
  const [aiLastName, setAILastName] = useState();
  const [getStatus, setStatus] = useState();
  const [aiEmail, setEmail] = useState();
  const [aiDate, setDate] = useState();
  const [aiUpdatedBy, setUpdatedBy] = useState();
  const handleOpen = (row) => {
    const d = new Date(row?.date_requested);

    // return <span>{d?.toLocaleDateString()}</span>;

    setOpen(true);
    setID(row?.id);
    setAIName(row?.firstname);
    setAILastName(row?.lastname);
    setEmail(row?.email);
    setStatus(row?.request_status);
    setDate(d?.toLocaleDateString());
    setUpdatedBy(row?.approvedBy);
  };

  function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress
            style={{ width: 200, height: 5 }}
            variant="determinate"
            color={props.value > 50 ? "primary" : "secondary"}
            {...props}
          />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  // const search = (data) => {
  //   return data?.filter(
  //     (item) =>
  //       item?.firstname?.toLowerCase()?.includes(query) ||
  //       item?.lastname?.toLowerCase()?.includes(query) ||
  //       item?.email?.toLowerCase()?.includes(query) ||
  //       item?.mobile?.toLowerCase()?.includes(query)
  //   );
  // };

  const handleQuery = useCallback(
    debounce((e) => {
      setQuery(e.target.value);
      setPageState({ ...pageState, page: 1 });
    }, 1000)
  );

  const fetchuserData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-accredited-userdetails",
      headers: {
        "x-access-token": token,
      },
      data: {
        page: pageState.page,
        limit: pageState.pageSize,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
        setPercentage(response?.data?.data?.percent);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchuserData();
  }, [pageState.page, pageState.pageSize, query]);

  // const {
  //   register,
  //   setValue,
  //   formState: { errors },
  // } = useForm({
  //   mode: "all",
  // });

  // Person-first WP6b: the decision is about the REQUEST's account (api WP5,
  // accreditedInvestor.controller requestAccountOf). The list read selects no
  // investor_account_id, so this page cannot tell a stamped request or a user
  // with two accounts: it sends the body as before, and on the server's 400
  // ACCOUNT_KIND_REQUIRED it closes the request (its focus trap would hold the
  // question's radios), asks "Personal" or "Company" and sends once more with
  // account_kind (sendNamingAccountOnce).
  const askingOnTheList = {
    beforeAsk: () => {
      setLoading(false);
      setOpen(false);
    },
    afterAsk: () => setLoading(true),
  };

  const approveAccreditedInvestors = () => {
    const token = localStorage.getItem("accessToken");
    const date = new Date().toLocaleString() + "";
    setLoading(true);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API + "admin/approve-disaprove",
      headers: {
        "x-access-token": token,
      },
      data: {
        id: id,
        request_status: 1,
        datestatusUpdated: date,
      },
    };
    sendNamingAccountOnce((data) => axios({ ...config, data }), config.data, askingOnTheList)
      .then(function ({ response, cancelled }) {
        if (cancelled) return;
        if (response.data.status == true) {
          setLoading(false);
          setOpen(false);
          Swal.fire({
            title: "Approve Successfully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        fetchuserData();
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text:
            error?.response?.status === 403
              ? DECIDE_FORBIDDEN
              : apiErrorMessage(error, "Approval failed"),
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      });
  };
  const rejectAccreditedInvestors = () => {
    const token = localStorage.getItem("accessToken");
    const date = new Date().toLocaleString() + "";
    setLoading(true);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API + "admin/approve-disaprove",
      headers: {
        "x-access-token": token,
      },
      data: {
        id: id,
        request_status: 2,
        datestatusUpdated: date,
      },
    };

    sendNamingAccountOnce((data) => axios({ ...config, data }), config.data, askingOnTheList)
      .then(function ({ response, cancelled }) {
        if (cancelled) return;
        if (response.data.status == true) {
          setLoading(false);
          setOpen(false);
          Swal.fire({
            title: "Rejected Succesffully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        fetchuserData();
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text:
            error?.response?.status === 403
              ? DECIDE_FORBIDDEN
              : apiErrorMessage(error, "Rejection failed"),
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 80,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              // to={`/investors/${params.row.id} `}
              to={`/users/${params.row.user_id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
          </div>
        );
      },
    },
  ];
  const requestColumn = [
    {
      field: "request",
      headerName: "Request",
      flex: 1,
      minWidth: 160,
      renderCell: (params) => {
        // console.log('params',params.row.id)
        return (
          <div className="cellRequest">
            <Button
              className="requestView-btn"
              onClick={() => handleOpen(params.row)}
            >
              View Request
            </Button>

            <Modal
              open={open}
              onClose={() => setOpen(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="modal-popup">
                <div className="modal-top">
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Update Accredited Investor Request
                  </Typography>
                  <Button className="closeBtn" onClick={() => setOpen(false)}>
                    <img src={Close} alt="close-icon" />
                  </Button>
                </div>
                {/* component="div": Typography renders a <p> by default and
                    the body below is a form full of divs, which is invalid
                    nesting the browser silently reflows. */}
                <Typography id="modal-modal-description" component="div" sx={{ mt: 1 }}>
                  <div className="new">
                    <div className="newContainer">
                      <div
                        className="bottom"
                        style={{ boxShadow: "none", padding: "0" }}
                      >
                        <div className="right">
                          <form className="accredited-investorForm">
                            <div className="formInput">
                              <label>First Name</label>
                              <input
                                type="text"
                                name="firstname"
                                disabled={true}
                                // {...register("firstname")}
                                value={aiName}
                                placeholder="Enter First Name"
                              />
                            </div>
                            <div className="formInput">
                              <label>Last Name</label>
                              <input
                                type="text"
                                name="lastname"
                                disabled={true}
                                // {...register("lastname")}
                                value={aiLastName}
                                placeholder="Enter Last Name"
                              />
                            </div>
                            <div className="formInput">
                              <label>Email</label>
                              <input
                                type="email"
                                name="email"
                                disabled={true}
                                value={aiEmail}
                                placeholder="Enter Email"
                              />
                            </div>
                            <div className="formInput">
                              <label>Updated At</label>
                              <input
                                type="text"
                                name="aiDate"
                                disabled={true}
                                value={aiDate}
                                placeholder="Enter Email"
                              />
                            </div>
                            <div className="formInput">
                              <label>Approved By</label>
                              <input
                                type="text"
                                name="aiUpdatedBy"
                                disabled={true}
                                value={aiUpdatedBy}
                                // placeholder="Enter Email"
                              />
                            </div>
                            <div className="formInput">
                              <label>Status</label>
                              <input
                                type="text"
                                name="status"
                                disabled={true}
                                value={
                                  getStatus == 1
                                    ? "Approved"
                                    : getStatus == 2
                                    ? "Rejected"
                                    : "In-Review"
                                }
                                // placeholder="Enter Email"
                              />
                            </div>

                            <div className="item accreditedItem">
                              <div className="details profile-info">
                                <div className="submitButton">
                                  {!canDecide ? (
                                    <>
                                      <button
                                        className="approveButton"
                                        type="button"
                                        disabled
                                        title={OVERSIGHT_HINT}
                                      >
                                        Approve
                                      </button>
                                      <button
                                        className="declineButton"
                                        type="button"
                                        disabled
                                        title={OVERSIGHT_HINT}
                                      >
                                        Reject
                                      </button>
                                      <button
                                        className="cancelButton"
                                        type="button"
                                        onClick={() => setOpen(false)}
                                      >
                                        Close
                                      </button>
                                      <span className="field__hint">
                                        {OVERSIGHT_HINT}
                                      </span>
                                    </>
                                  ) : getStatus == 2 ? (
                                    <>
                                      <button
                                        className="approveButton"
                                        type="button"
                                        onClick={() =>
                                          approveAccreditedInvestors()
                                        }
                                      >
                                        Approve
                                      </button>
                                      <button
                                        className="cancelButton"
                                        type="button"
                                        onClick={() => setOpen(false)}
                                      >
                                        Close
                                      </button>
                                    </>
                                  ) : getStatus == 1 ? (
                                    <>
                                      <button
                                        className="declineButton"
                                        type="button"
                                        onClick={() =>
                                          rejectAccreditedInvestors()
                                        }
                                      >
                                        Reject
                                      </button>
                                      <button
                                        className="cancelButton"
                                        type="button"
                                        onClick={() => setOpen(false)}
                                      >
                                        Close
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        className="approveButton"
                                        type="button"
                                        onClick={() =>
                                          approveAccreditedInvestors()
                                        }
                                      >
                                        Approve
                                      </button>
                                      <button
                                        className="declineButton"
                                        type="button"
                                        onClick={() =>
                                          rejectAccreditedInvestors()
                                        }
                                      >
                                        Reject
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </Typography>
              </Box>
            </Modal>
          </div>
        );
      },
    },
  ];

  const statusColumn = [
    {
      field: "request_status",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <span
              className={`status ${
                params.row.request_status == 1
                  ? "Approved"
                  : params.row.request_status == 2
                  ? "Pending"
                  : "In-Review"
              }`}
            >
              {params.row.request_status == 1
                ? "Approved"
                : params.row.request_status == 2
                ? "Rejected"
                : "In-Review"}
            </span>
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    // {
    //   field: "profilePic",
    //   headerName: "Profile",
    //   width: 100,
    //   renderCell: (params) => {
    //     let progressCircularbar = percentage;
    //     return (
    //       <div className="cellWrapper ">
    //         <div className="profilePic">
    //           <img
    //             src={
    //               params.row.profilePic == null
    //                 ? ProfilePic
    //                 : params?.row?.profilePic
    //             }
    //             className="userImage"
    //           />
    //           {progressCircularbar
    //             ?.filter((d) => d?.userid == params.row.id)
    //             ?.map((percentile) => (
    //               <CircularProgressbar
    //                 key={percentile?.userid}
    //                 value={percentile?.percentage}
    //                 className="adminProfile-progress"
    //               />
    //             ))}
    //         </div>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "firstname",
      headerName: "First Name",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "lastname",
      headerName: "Last Name",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "date_requested",
      headerName: "Date Requested",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const d = new Date(params.row.date_requested);

        return <span>{d?.toLocaleDateString()}</span>;
      },
    },
    {
      field: "approvedBy",
      headerName: "Updated By",
      flex: 1,
      minWidth: 200,
    },
  ];

  return (
    <PageShell><PageHead title="Accredited investors" /><div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input type="text" placeholder="Search..." onChange={handleQuery} />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Accredited Investors</h5>
        <div></div>
      </div>
      <DataGrid
        className="datagrid"
        autoHeight
        rows={pageState.data}
        rowCount={pageState.total}
        rowsPerPageOptions={[10, 30, 50, 70, 100]}
        pagination
        page={pageState.page - 1}
        pageSize={pageState.pageSize}
        paginationMode="server"
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...old, page: newPage + 1 }));
        }}
        onPageSizeChange={(newPageSize) =>
          setPageState((old) => ({ ...old, pageSize: newPageSize }))
        }
        columns={userColumns.concat(statusColumn, requestColumn, actionColumn)}
      />
    </div></PageShell>
  );
};

export default InvestorsList;
